import { useState } from "react";
import { Switch } from "antd";

import "./switch-custom.css"; // Import custom switch styles

export default function NotificationSettings() {
  // State for notification channels
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [inAppNotifications, setInAppNotifications] = useState(true);
  const [whatsappNotifications, setWhatsappNotifications] = useState(true);

  // State for notification types
  const [appointmentReminders, setAppointmentReminders] = useState(true);
  const [feedbackNotifications, setFeedbackNotifications] = useState(true);
  const [eventInvites, setEventInvites] = useState(true);
  const [reportNotifications, setReportNotifications] = useState(true);

  return (
    <div className="w-fulls mx-auto p-[16px] bg-white ">
      <h1 className="text-[18px] font-semibold text-[#171717]">
        Notification Settings (Managed by Admin)
      </h1>

      <p className="text-[14px] text-[#171717]">
        Choose how and where you receive updates about appointments, events, and
        user interactions.
      </p>

      <div className="border-t  pt-2 border-[#E2E8F0]">
        {/* Notification Channels */}
        <div className="space-y-4 w-full lg:w-1/2">
          <div className="flex items-center justify-between ">
            <span className="text-grey text-[14px] font-poppins">
              Email Notifications
            </span>
            <Switch
              disabled
              checked={emailNotifications}
              onChange={setEmailNotifications}
              className="custom-switch"
            />
          </div>

          <div className="flex items-center justify-between  ">
            <span className="text-grey text-[14px] font-poppins">
              In-App Notifications
            </span>
            <Switch
              disabled
              checked={inAppNotifications}
              onChange={setInAppNotifications}
              className="custom-switch"
            />
          </div>

          <div className="flex items-center justify-between  border-gray-100">
            <span className="text-grey text-[14px] font-poppins">
              WhatsApp/SMS Updates
            </span>
            <Switch
              disabled
              checked={whatsappNotifications}
              onChange={setWhatsappNotifications}
              className="custom-switch"
            />
          </div>
        </div>
      </div>

      {/* Notification Types */}
      <div className="mt-[16px] border-t border-[#E2E8F0]">
        <h2 className="text-[14px] font-bold text-gray-900 mb-4  mt-[16px]">
          Notification Types
        </h2>

        <div className="space-y-4 w-full lg:w-1/2">
          <div className="flex items-center justify-between">
            <span className="text-[14px] text-grey font-poppins">
              Appointment Reminders
            </span>
            <Switch
              disabled
              checked={appointmentReminders}
              onChange={setAppointmentReminders}
              className="custom-switch"
            />
          </div>

          <div className="flex items-center justify-between">
            <span className="text-[14px] text-grey font-poppins">
              New Feedback Received
            </span>
            <Switch
              disabled
              checked={feedbackNotifications}
              onChange={setFeedbackNotifications}
              className="custom-switch"
            />
          </div>

          <div className="flex items-center justify-between ">
            <span className="text-[14px] text-grey font-poppins">
              Event Participation Invites
            </span>
            <Switch
              disabled
              checked={eventInvites}
              onChange={setEventInvites}
              className="custom-switch"
            />
          </div>

          <div className="flex items-center justify-between ">
            <span className="text-[14px] text-grey font-poppins">
              Report Upload Notifications
            </span>
            <Switch
              disabled
              checked={reportNotifications}
              onChange={setReportNotifications}
              className="custom-switch"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
